import { render } from "./RecordingsPage.vue?vue&type=template&id=1ec4c274"
import script from "./RecordingsPage.vue?vue&type=script&lang=js"
export * from "./RecordingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__